import React, { Component, createRef } from 'react';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    Collapse,
    TableCell,
    CircularProgress
} from '@material-ui/core';
import swal from 'sweetalert';
import { FormattedMessage, injectIntl } from 'react-intl';
import AjaxHandler from '../../commons/ajax/AjaxHandler.js';
import { StyledTableCell } from '../../commons/utils/TableStyles.js';
import PresupuestoDetail from './PresupuestoDetail.jsx';
import PresupuestoAsignacion from './PresupuestoAsignacion.jsx';
import PresupuestoHistorico from './PresupuestoHistorico.jsx';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import Security from '../../commons/security/Security.js';

class PeriodoPresupuestarioPresupuestoGrid extends Component {

    constructor(props) {
        super(props);
        this.ajaxHandler = new AjaxHandler();
        this.inputRefs = [];
        this.presupuestoHistoricoRef = createRef();
        this.state = {
            presupuestos:       [],
            loading:            false,
            presupuestosBackup: [],
            expandedRows:       [],
            expandedRowsChild:  [],
            isHidden:           'hidden-personal',
            disponibles:        {},
            totales:            {},
            porcentaje:         ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
            editingAll:         false,
        };
        this.handleEditAll = this.handleEditAll.bind(this);
        this.saveAll = this.saveAll.bind(this);
        this.cancelAll = this.cancelAll.bind(this);
    }

    componentWillMount() {
        this.ajaxHandler.subscribe(this);
        this.initForm();
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe();
    }

    initForm() {
        this.setState({ loading: true });
        Promise.all([
            this.ajaxHandler.getJson('/presupuestos/' + this.props.modulo + '/' + this.props.id + '/lista'),
            this.ajaxHandler.getJson('/presupuestos/' + this.props.presupuestable + '/' + this.props.id + '/init-data'),
        ]).then(([presupuestosData, initData]) => {
            const resumenData    = initData.resumenTodos;
            const inicioPeriodo  = initData.periodoIniciado;
            this.inicioPeriodo   = inicioPeriodo;
            let presupuestos     = [];
            let disponibles      = {};
            let totales          = {};

            for (const presupuesto of presupuestosData) {
                const total = parseFloat(presupuesto.monto_general) +
                    parseFloat(presupuesto.monto_correctivo) +
                    parseFloat(presupuesto.monto_preventivo) +
                    parseFloat(presupuesto.monto_gestoria) +
                    parseFloat(presupuesto.monto_vencimientos);

                const resumen      = resumenData.find(r => r.presupuesto_id === presupuesto.id) || {};
                const distribuido  = parseFloat(resumen.distribuido)  || 0;
                const comprometido = parseFloat(resumen.comprometido) || 0;
                const consumido    = parseFloat(resumen.consumido)    || 0;
                const disponible   = this.props.modulo !== 'bases'
                    ? total - distribuido
                    : total - (comprometido + consumido);

                disponibles[presupuesto.id] = disponible;
                totales[presupuesto.id]     = total;

                presupuestos.push({
                    ...presupuesto,
                    monto_general:      parseFloat(presupuesto.monto_general),
                    monto_preventivo:   parseFloat(presupuesto.monto_preventivo),
                    monto_correctivo:   parseFloat(presupuesto.monto_correctivo),
                    monto_gestoria:     parseFloat(presupuesto.monto_gestoria),
                    monto_vencimientos: parseFloat(presupuesto.monto_vencimientos),
                    periodo:            presupuesto.periodo,
                    resumen:            { distribuido, comprometido, consumido },
                });
            }

            presupuestos.sort((a, b) => new Date(a.periodo.fecha_inicio) - new Date(b.periodo.fecha_inicio));

            this.setState({ presupuestos, presupuestosBackup: JSON.parse(JSON.stringify(presupuestos)), disponibles, totales, loading: false });
        }).catch(error => {
            console.error('Error al inicializar el formulario:', error);
            this.setState({ loading: false });
        });
    }

    handleEditAll() {
        this.setState({ editingAll: true });
    }

    handleInputFormChange(event, key) {
        const { name, value } = event.target;
        let presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestos));
        presupuestosCopy[key][name] = value;
        this.setState({ presupuestos: presupuestosCopy });
    }

    cancelAll() {
        var presupuestosCopy = JSON.parse(JSON.stringify(this.state.presupuestosBackup));
        this.setState({ presupuestos: presupuestosCopy, editingAll: false });
    }

    saveAll() {
        var self   = this;
        var fields = ['monto_general', 'monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos'];
        var changed = this.state.presupuestos.filter(function(p, key) { return self.diferentePresupuesto(key); });

        if (changed.length === 0) {
            this.setState({ editingAll: false });
            return;
        }

        // Validaciones síncronas frontend antes de ir al servidor
        for (var i = 0; i < changed.length; i++) {
            var p      = changed[i];
            var montos = {};
            fields.forEach(function(f) { montos[f] = parseFloat(p[f]) || 0; });

            if (fields.some(function(f) { return montos[f] < 0; })) {
                swal('Monto no válido', 'Los montos no pueden ser negativos.', 'warning');
                return;
            }

            var otrosMontos = ['monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos'];
            if (montos.monto_general > 0 && otrosMontos.some(function(f) { return montos[f] > 0; })) {
                swal('Monto no válido', 'Si se ingresa monto general, los demás montos deben ser 0.', 'warning');
                return;
            }
        }

        this.props.setLoading(true);

        Promise.all(
            changed.map(function(p) {
                return self.getTotalesHijos(self.props.id, p.periodo_id, self.props.presupuestable)
                    .then(function(totalesHijos) { return { p: p, totalesHijos: totalesHijos }; });
            })
        ).then(function(results) {
            var invalid = results.some(function(r) {
                return fields.some(function(f) { return parseFloat(r.p[f]) < r.totalesHijos[f]; });
            });
            if (invalid) {
                swal('Monto no válido', 'Uno o más montos son inconsistentes respecto a lo ya distribuido.', 'warning');
                throw new Error('validation_failed');
            }

            return Promise.all(
                changed.map(function(p) {
                    var body = {
                        monto_general:      parseFloat(p.monto_general)      || 0,
                        monto_preventivo:   parseFloat(p.monto_preventivo)   || 0,
                        monto_correctivo:   parseFloat(p.monto_correctivo)   || 0,
                        monto_gestoria:     parseFloat(p.monto_gestoria)      || 0,
                        monto_vencimientos: parseFloat(p.monto_vencimientos) || 0,
                    };
                    return self.ajaxHandler.fetch('/presupuestos/' + p.id, {
                        method: 'PATCH',
                        body: JSON.stringify(body),
                    }).then(function(response) {
                        if (response.status === 400) {
                            return response.json().then(function(data) {
                                swal(data.detalle[0], '', 'error');
                                throw new Error('api_error');
                            });
                        }
                    });
                })
            );
        }).then(function() {
            self.setState({ editingAll: false });
            self.initForm();
            self.props.setLoading(false);
            if (self.props.onPresupuestoUpdated) self.props.onPresupuestoUpdated();
        }).catch(function(error) {
            if (error.message !== 'validation_failed') {
                self.setState({ editingAll: false });
                self.initForm();
            }
            self.props.setLoading(false);
            if (error.message !== 'validation_failed' && error.message !== 'api_error') {
                self.ajaxHandler.handleError(error);
            }
        });
    }

    getTotalesHijos(presupuestoId, periodoId, presupuestableType) {
        return this.ajaxHandler
            .getJson('/presupuestos/subregiones-bases/' + presupuestoId + '?periodoId=' + periodoId + '&presupuestableType=' + presupuestableType)
            .then(response => response.reduce((totales, item) => {
                totales.monto_general      += parseFloat(item.monto_general)      || 0;
                totales.monto_preventivo   += parseFloat(item.monto_preventivo)   || 0;
                totales.monto_correctivo   += parseFloat(item.monto_correctivo)   || 0;
                totales.monto_gestoria     += parseFloat(item.monto_gestoria)     || 0;
                totales.monto_vencimientos += parseFloat(item.monto_vencimientos) || 0;
                return totales;
            }, { monto_general: 0, monto_preventivo: 0, monto_correctivo: 0, monto_gestoria: 0, monto_vencimientos: 0 }))
            .catch(error => {
                console.error('Error al obtener totales de hijos:', error);
                return { monto_general: 0, monto_preventivo: 0, monto_correctivo: 0, monto_gestoria: 0, monto_vencimientos: 0 };
            });
    }

    diferentePresupuesto(key) {
        const fields = ['monto_general', 'monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos'];
        return fields.some(f => (parseFloat(this.state.presupuestos[key][f]) || 0) !== (parseFloat(this.state.presupuestosBackup[key][f]) || 0));
    }

    handleAsignacionChange = (presupuestoId, newDistribuido) => {
        this.setState(prevState => {
            const total        = prevState.totales[presupuestoId] || 0;
            const presupuesto  = prevState.presupuestos.find(p => p.id === presupuestoId);
            const oldDistribuido = presupuesto ? (parseFloat((presupuesto.resumen || {}).distribuido) || 0) : 0;
            const delta        = newDistribuido - oldDistribuido;
            return {
                disponibles: { ...prevState.disponibles, [presupuestoId]: total - newDistribuido },
                presupuestos: prevState.presupuestos.map(p =>
                    p.id === presupuestoId ? { ...p, resumen: { ...p.resumen, distribuido: newDistribuido } } : p
                ),
            };
        }, () => {
            if (this.props.onPresupuestoUpdated) this.props.onPresupuestoUpdated();
        });
    }

    toggleCollapse(key) {
        this.setState(prevState => {
            const isExpanded = prevState.expandedRows.includes(key);
            return {
                expandedRows:      isExpanded ? [] : [key],
                expandedRowsChild: [],
                isHidden:          isExpanded ? 'hidden-personal' : 'block',
            };
        });
    }

    toggleCollapseChild(key) {
        this.setState(prevState => {
            const isExpanded = prevState.expandedRowsChild.includes(key);
            return {
                expandedRowsChild: isExpanded ? [] : [key],
                expandedRows:      [],
            };
        });
    }

    updatePresupuesto(id, rowData) {
        const body = {
            monto_general:      parseFloat(rowData.monto_general),
            monto_preventivo:   parseFloat(rowData.monto_preventivo),
            monto_correctivo:   parseFloat(rowData.monto_correctivo),
            monto_gestoria:     parseFloat(rowData.monto_gestoria),
            monto_vencimientos: parseFloat(rowData.monto_vencimientos),
        };
        return this.ajaxHandler.fetch('/presupuestos/' + id, {
            method: 'PATCH',
            body: JSON.stringify(body),
        }).then(response => {
            if (response.status === 400) {
                return response.json().then(data => swal(data.detalle[0], '', 'error'));
            }
        }).catch(error => {
            this.ajaxHandler.handleError(error);
        }).finally(() => {
            this.initForm();
            this.props.setLoading(false);
        });
    }

    getIconColor(disponible, totales) {
        if (totales === 0 && disponible === 0) return 'gray';
        const pct = (disponible / totales) * 100;
        if (pct === 100) return '#474789';
        if (pct >= this.state.porcentaje) return '#28D094';
        if (pct > 0) return '#F1EA7F';
        return '#FF4961';
    }

    handleVerHistorico = () => {
        if (this.presupuestoHistoricoRef.current) {
            this.presupuestoHistoricoRef.current.fetchPresupuestoHistorico();
        }
    }

    render() {
        return (
            <div className="card" style={{ borderLeftColor: '#00c0bd' }}>
                <div className="card-content">
                    <div className="card-body">
                        {this.state.loading ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <>
                                <div className="row">
                                    <TableContainer>
                                        <Table aria-label="presupuesto-table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '30px' }}></StyledTableCell>
                                                    <StyledTableCell>
                                                        <FormattedMessage id="presupuestoGrid.presupuesto_table.column_nombre_periodo.label" defaultMessage="NOMBRE DEL PERIODO" />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <FormattedMessage id="presupuestoGrid.presupuesto_table.column_fecha_inicio.label" defaultMessage="FECHA INICIO" />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <FormattedMessage id="presupuestoGrid.presupuesto_table.column_fecha_fin.label" defaultMessage="FECHA FIN" />
                                                    </StyledTableCell>
                                                    {this.props.modulo !== 'bases' && (
                                                        <StyledTableCell style={{ width: '60px' }}>
                                                            {this.props.modulo === 'regiones'
                                                                ? <FormattedMessage id="presupuestoGrid.presupuesto_table.column_subregiones" defaultMessage="SUBREGIONES" />
                                                                : <FormattedMessage id="presupuestoGrid.presupuesto_table.column_bases" defaultMessage="BASES" />
                                                            }
                                                        </StyledTableCell>
                                                    )}
                                                    <StyledTableCell><FormattedMessage id="presupuestoGrid.presupuesto_table.column_general.label" defaultMessage="GENERAL" /></StyledTableCell>
                                                    <StyledTableCell><FormattedMessage id="presupuestoGrid.presupuesto_table.column_preventivo.label" defaultMessage="PREVENTIVO" /></StyledTableCell>
                                                    <StyledTableCell><FormattedMessage id="presupuestoGrid.presupuesto_table.column_correctivo.label" defaultMessage="CORRECTIVO" /></StyledTableCell>
                                                    <StyledTableCell><FormattedMessage id="presupuestoGrid.presupuesto.column_gestoria.label" defaultMessage="GESTORIA" /></StyledTableCell>
                                                    <StyledTableCell><FormattedMessage id="presupuestoGrid.presupuesto.column_vencimientos.label" defaultMessage="VENCIMIENTO" /></StyledTableCell>
                                                    {this.props.modulo === 'regiones' && this.props.editar && (!this.inicioPeriodo || Security.hasPermission('PERIODO_PRESUPUESTARIO_MONTOS_EDITAR_INICIADO')) && (
                                                        <StyledTableCell align="center">
                                                            {this.state.editingAll ? (
                                                                <>
                                                                    <button type="button" className="btn btn-sm btn-icon btn-dt-grid text-success" onClick={() => this.saveAll()} style={{ width: '30px' }}>
                                                                        <i className="fa fa-check fa-xs" />
                                                                    </button>
                                                                    <button type="button" className="btn btn-sm btn-icon btn-dt-grid text-danger" onClick={() => this.cancelAll()} style={{ width: '30px' }}>
                                                                        <i className="fa fa-times fa-xs" />
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                <button type="button" className="btn btn-sm btn-icon btn-dt-grid text-success" onClick={() => this.handleEditAll()} style={{ width: '30px' }}>
                                                                    <i className="fa fa-pencil fa-xs" />
                                                                </button>
                                                            )}
                                                        </StyledTableCell>
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {this.state.presupuestos.map((presupuesto, key) => {
                                                    const hasMontoGeneral = presupuesto.monto_general > 0;
                                                    const hasOtherMontos  = ['monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos'].some(f => presupuesto[f] > 0);
                                                    const disponible      = this.state.disponibles[presupuesto.id] || 0;
                                                    const totales         = this.state.totales[presupuesto.id]     || 0;
                                                    const color           = this.getIconColor(disponible, totales);

                                                    return (
                                                        <React.Fragment key={key}>
                                                            <TableRow>
                                                                <StyledTableCell>
                                                                    <div className="d-flex align-items-center">
                                                                        <div onClick={() => this.toggleCollapse(key)}>
                                                                            {this.state.expandedRows.includes(key)
                                                                                ? <i className="fa fa-2x fa-angle-double-down personal-no-focus avatar-plus-detail pointer"></i>
                                                                                : <i className="fa fa-angle-double-right fa-2x personal-no-focus avatar-plus-detail pointer"></i>
                                                                            }
                                                                        </div>
                                                                        <i
                                                                            className="fa fa-circle"
                                                                            style={{ color: color, fontSize: '1.5rem', marginLeft: '10px' }}
                                                                            title={totales === 0 ? 'Sin presupuesto asignado' : 'Restante:' + disponible}
                                                                        ></i>
                                                                    </div>
                                                                </StyledTableCell>
                                                                <StyledTableCell>
                                                                    <div className="text-center" style={{ minWidth: '50px' }}>
                                                                        {presupuesto.periodo ? presupuesto.periodo.nombre : ''}
                                                                    </div>
                                                                </StyledTableCell>
                                                                <StyledTableCell>{presupuesto.periodo ? presupuesto.periodo.fecha_inicio : ''}</StyledTableCell>
                                                                <StyledTableCell>{presupuesto.periodo ? presupuesto.periodo.fecha_fin : ''}</StyledTableCell>
                                                                {this.props.modulo !== 'bases' && (
                                                                    <StyledTableCell>
                                                                        <div className="d-flex align-items-center" style={{ justifyContent: 'center' }}>
                                                                            <div onClick={() => this.toggleCollapseChild(key)}>
                                                                                {this.state.expandedRowsChild.includes(key)
                                                                                    ? <i className="fa fa-2x fa-angle-double-down personal-no-focus avatar-plus-detail pointer"></i>
                                                                                    : <i className="fa fa-angle-double-right fa-2x personal-no-focus avatar-plus-detail pointer"></i>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </StyledTableCell>
                                                                )}
                                                                <StyledTableCell style={{ backgroundColor: !this.state.editingAll && hasOtherMontos ? '#d3d3d3' : 'inherit' }}>
                                                                    {this.state.editingAll ? (
                                                                        <input
                                                                            ref={el => (this.inputRefs[key + 'monto_general'] = el)}
                                                                            type="number" name="monto_general"
                                                                            value={presupuesto.monto_general === 0 ? '' : presupuesto.monto_general}
                                                                            onChange={e => this.handleInputFormChange(e, key)}
                                                                            placeholder="0" style={{ width: '110px' }} disabled={hasOtherMontos}
                                                                        />
                                                                    ) : presupuesto.monto_general}
                                                                </StyledTableCell>
                                                                {['monto_preventivo', 'monto_correctivo', 'monto_gestoria', 'monto_vencimientos'].map(field => (
                                                                    <StyledTableCell key={field} style={{ backgroundColor: !this.state.editingAll && hasMontoGeneral ? '#d3d3d3' : 'inherit' }}>
                                                                        {this.state.editingAll ? (
                                                                            <input
                                                                                ref={el => (this.inputRefs[key + field] = el)}
                                                                                type="number" name={field}
                                                                                value={presupuesto[field] === 0 ? '' : presupuesto[field]}
                                                                                onChange={e => this.handleInputFormChange(e, key)}
                                                                                placeholder="0" style={{ width: '110px' }} disabled={hasMontoGeneral}
                                                                            />
                                                                        ) : presupuesto[field]}
                                                                    </StyledTableCell>
                                                                ))}
                                                                {this.props.modulo === 'regiones' && this.props.editar && (!this.inicioPeriodo || Security.hasPermission('PERIODO_PRESUPUESTARIO_MONTOS_EDITAR_INICIADO')) && (
                                                                    <StyledTableCell />
                                                                )}
                                                            </TableRow>
                                                            <TableRow className={this.state.isHidden}>
                                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }} colSpan={11}>
                                                                    <Collapse in={this.state.expandedRows.includes(key)} timeout={{ enter: 700, exit: 500 }} unmountOnExit>
                                                                        <PresupuestoDetail presupuesto={presupuesto} relacion={this.props} />
                                                                    </Collapse>
                                                                </TableCell>
                                                            </TableRow>
                                                            {this.props.modulo !== 'bases' && (
                                                            <TableRow>
                                                                <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: 'rgb(244, 245, 250)' }} colSpan={11}>
                                                                    <Collapse in={this.state.expandedRowsChild.includes(key)} timeout={{ enter: 700, exit: 500 }} unmountOnExit>
                                                                        <PresupuestoAsignacion presupuesto={presupuesto} relacion={this.props} onAsignacionChange={this.handleAsignacionChange} />
                                                                    </Collapse>
                                                                </TableCell>
                                                            </TableRow>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>

                                {this.props.modulo === 'regiones' && (
                                    <div className="row mt-1">
                                        <div className="col-md-12 d-flex justify-content-end">
                                            <button
                                                type="button" className="btn btn-primary"
                                                data-toggle="modal" data-target="#verHistoricoPP_modal"
                                                onClick={this.handleVerHistorico}
                                            >
                                                <FormattedMessage id="presupuestoGrid.button.ver_historico" defaultMessage="Ver Histórico" />
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>

                <div className="modal fade" tabIndex="-1" id="verHistoricoPP_modal" role="dialog">
                    <div className="modal-xl modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header bg-fleet">
                                <h4 className="modal-title text-white">
                                    <FormattedMessage id="presupuestoGrid_modal.title.historico" defaultMessage="Histórico de Presupuestos" />
                                </h4>
                                <button type="button" className="close" data-dismiss="modal"><span>&times;</span></button>
                            </div>
                            <div className="modal-body modal-mh ovf-x-hidden">
                                <PresupuestoHistorico region={this.props.id} ref={this.presupuestoHistoricoRef} />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default btn-fleet" data-dismiss="modal">
                                    <FormattedMessage id="presupuestoGrid_modal.finish_button.ok" defaultMessage="Ok" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(PeriodoPresupuestarioPresupuestoGrid);
